import React from 'react';

import { fg } from '@confluence/feature-gating';

import { Bm3PageLoadMarkFMP } from '../Bm3PageLoadMarkFMP.tsx';

import { UFOLoadMarkFMP } from './UFOLoadMarkFMP.tsx';

type PageLoadMarkFMPProps = {
	timestamp?: number;
};

/**
 * Interop component that renders either the new UFOLoadMarkFMP (which records a
 * UFO custom FMP mark) or the legacy Bm3PageLoadMarkFMP (which creates BM3 FMP
 * marks) based on the `confluence_fe_deprecate_bm3` feature gate.
 */
export const PageLoadMarkFMP = (props: PageLoadMarkFMPProps) => {
	if (fg('confluence_fe_deprecate_bm3')) {
		return <UFOLoadMarkFMP {...props} />;
	}

	return <Bm3PageLoadMarkFMP {...props} />;
};
